<template>
  <MenuCard title="Lights" tooltip="Light settings will help you change how light will affect your model">
      <v-card-text class="">
        <div>
          <Row title="Enable Environment">
          <v-switch class="pb-2 ma-0" v-model="isEnvironmentEnabled" hide-details></v-switch>
          </Row>
          <Row title="Enable Lights">
            <v-switch class="pa-0 ma-0 mb-4" v-model="isLightsEnabled" hide-details></v-switch>
          </Row>
          <Row title="Tone Mapping Exposure">
            <NumberController v-model="toneMappingExposure"></NumberController>
          </Row>
          <Row title="Ambient Intensity">
            <NumberController v-model="ambientIntensity"></NumberController>
          </Row>
          <Row title="Ambient Color">
            <ColorPicker v-model="ambientColor"></ColorPicker>
          </Row>
          <Row title="Direct Intensity">
            <NumberController v-model="directIntensity"></NumberController>
          </Row>
          <Row title="Direct Color">
            <ColorPicker v-model="directColor"></ColorPicker>
          </Row>
          <Row title="Show Direct Light">
            <v-switch class="pa-0 ma-0 mb-4" v-model="isShowDirectionalLight" hide-details></v-switch>
          </Row>
          <Row title="Direct Position">
            <NumberController precision=2 width="50" v-model="directX"></NumberController>
            <NumberController precision=2 width="50" v-model="directY"></NumberController>
            <NumberController precision=2 width="50" v-model="directZ"></NumberController>
          </Row>
          <Row title="Direct Rotation">
            <NumberController precision=2 width="50" v-model="rotationX"></NumberController>
            <NumberController precision=2 width="50" v-model="rotationY"></NumberController>
            <NumberController precision=2 width="50" v-model="rotationZ"></NumberController>
          </Row>
          <Row title="Texture Encoding">
            <v-select class="" hide-details dense outlined v-model="textureEncoding" :items="encodingItems"></v-select>
          </Row>
          <Row title="Output Encoding">
            <v-select class="" hide-details dense outlined v-model="outputEncoding" :items="encodingItems"></v-select>
          </Row>
        </div>
      </v-card-text>
  </MenuCard>
</template>

<script>
import MenuCard from './MenuCard.vue'
import ColorPicker from './ColorPicker.vue'
import Row from './Row.vue'
import NumberController from './NumberController.vue'

  export default {
    name: 'LightsMenu',
    components: {
        MenuCard,
        ColorPicker,
        Row,
        NumberController,
    },
    methods: {
        updateDirectionalLightPosition() {
            this.directPosition = { x: this.directX, y: this.directY, z: this.directZ };
        },
        updateDirectionalLightRotation() {
            this.directRotation = { x: this.rotationX, y: this.rotationY, z: this.rotationZ};
        },
    },
    
    mounted() {
    },

    data: function () {
        return {encodingItems: ["sRGB", "Linear"],
                directX: 0, directY: 0, directZ: 0,
                rotationX: 0, rotationY: 0, rotationZ: 0,};
    },

    props: [],
    watch: {
        directX: function() {
            this.updateDirectionalLightPosition();
        },
        directY: function() {
            this.updateDirectionalLightPosition();
        },
        directZ: function() {
            this.updateDirectionalLightPosition();
        },
        rotationX: function() {
            this.updateDirectionalLightRotation();
        },
        rotationY: function() {
            this.updateDirectionalLightRotation();
        },
        rotationZ: function() {
            this.updateDirectionalLightRotation();
        },
        directPosition: function() {
            this.directX = this.directPosition.x;
            this.directY = this.directPosition.y;
            this.directZ = this.directPosition.z;
        },
        directRotation: function() {
            this.rotationX = this.directRotation.x;
            this.rotationY = this.directRotation.y;
            this.rotationZ = this.directRotation.z;
        },
    },

    computed: {
        isShowDirectionalLight: {
            get() {
                return this.$store.state.lightSettings.isShowDirectionalLight;
            },
            set(value) {
                this.$store.commit('setIsShowDirectionalLight', value);
            },
        },
        directRotation: {
            get() {
                return this.$store.state.lightSettings.directLightRotation;
            },
            set(value) {
                this.$store.commit('setDirectLightRotation', value);
            },
        },
        directPosition: {
            get() {
                return this.$store.state.lightSettings.directLightPosition;
            },
            set(value) {
                this.$store.commit('setDirectLightPosition', value);
            },
        },
        isLightsEnabled: {
            get() {
                return this.$store.state.lightSettings.isLightsEnabled;
            },
            set(value) {
                this.$store.commit('setIsLightsEnabled', value);
            },
        },
        ambientIntensity: {
            get() {
                return this.$store.state.lightSettings.ambientIntensity;
            },
            set(value) {
                if (!value) {
                    value = 0;
                }
                let tmp = parseFloat(value);
                this.$store.commit('setAmbientIntensity', tmp);
            },
        },
        directIntensity: {
            get() {
                return this.$store.state.lightSettings.directIntensity;
            },
            set(value) {
                if (!value) {
                    value = 0;
                }
                let tmp = parseFloat(value);
                this.$store.commit('setDirectIntensity', tmp);
            },
        },
        ambientColor: {
            get() {
                return this.$store.state.lightSettings.ambientColor;
            },
            set(value) {
                this.$store.commit('setAmbientColor', value);
            },
        },
        directColor: {
            get() {
                return this.$store.state.lightSettings.directColor;
            },
            set(value) {
                this.$store.commit('setDirectColor', value);
            },
        },
        textureEncoding: {
            get() {
                return this.$store.state.lightSettings.textureEncoding;
            },
            set(value) {
                this.$store.commit('setTextureEncoding', value);
            },
        },
        outputEncoding: {
            get() {
                return this.$store.state.lightSettings.outputEncoding;
            },
            set(value) {
                this.$store.commit('setOutputEncoding', value);
            },
        },
        toneMappingExposure: {
            get() {
                return this.$store.state.lightSettings.toneMappingExposure;
            },
            set(value) {
                this.$store.commit('setToneMappingExposure', value);
            },
        },
        isEnvironmentEnabled: {
            get() {
                return this.$store.state.lightSettings.isEnvironmentEnabled;
            },
            set(value) {
                this.$store.commit('setIsEnvironmentEnabled', value);
            },
        },
    },
  }
</script>
